import * as React from "react";
import { List } from "Immutable";
import Face from "../face";
import { Table } from "react-bootstrap";
import { dieFaceToElement } from "./dieFaceDisplay";
import State from "../model";
import * as Selector from "../selector";
import { Dispatch } from "redux";
import { AppAction } from "../actions";
import { connect } from "react-redux";
import { StateWithHistory } from "redux-undo";

interface OddsProps {
    odds: List<{face: Face, odds: number}>;
}

class DieSummaryDisplay extends React.Component<OddsProps, {}> {
    public render(): JSX.Element {
        return <Table striped bordered>
            <tbody>
                {this.props.odds.map((o, i) => <tr key={i}><td className="oddsDie">{dieFaceToElement(o.face, "sm")}</td><td className="odds">{o.odds.toFixed(2)}%</td></tr>)}
            </tbody>
        </Table>;
    }
}

const mapStateToProps = (state: StateWithHistory<State>, ownProps: {}) => {
    return { odds: Selector.oddsTable(state.present.dice) };
}

const mapDispatchToProps = (dispatch: Dispatch<AppAction>) => ({ });

export default connect(mapStateToProps, mapDispatchToProps)(DieSummaryDisplay);
